<template>
    <div class="dilu-page">
        <div class="depart-view">
            <div class="depart-view-left">
                <div class="tree">
                    <el-row style="margin: 10px 0 20px 0;">
                        <el-col :span="18" class="wgtitle">监控摄像头</el-col>
                        <el-col :span="6">
                            <el-button class="addwg" type="text" icon="el-icon-document-add" @click="() => appendNode(data)">新增</el-button>
                        </el-col>
                    </el-row>
                    <div> </div>
                    <el-tree ref="tree" :data="dataList" node-key="id" @node-click="treeClick" :expand-on-click-node="false" default-expand-all>
                        <span class="custom-tree-node show-hide" slot-scope="{ data }">
                            <span>{{ data.cameraName + ' ['+data.cameraSn+']'}}</span>
                            <span style="display:none;">
                                <i @click="() => editNode(data)" class="el-icon-edit" style="margin-right:10px;" title="编辑"></i>
                                <i @click="() => removeNode(data)" class="el-icon-delete" title="删除"></i>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </div>
            <div class="depart-view-right">
                <div id="pageRight" ref="pageRight" class="page-right">
                    <template v-if="cameraItems.length>0">
                        <div class="camera-grid" :class="`grid-${cameraItems.length}`">
                            <EZUIKitPlayer
                                v-for="(camera, index) in cameraItems"
                                :key="camera.cameraSn"
                                :ref="`player${index + 1}`"
                                :playerId="`player-${camera.cameraSn}-${index}`"
                                :url="camera.playUrl"
                                :accessToken="camera.accessToken"
                                :rightWidth="rightWidth"
                                :template="template"
                                @ready="onPlayerReady"
                                @error="onPlayerError"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <CameraEdit :editVisible="editVisible" :projectCamera="projectCamera" @handleClose="handleClose"/>
    </div>
</template>


<script>
import { mapState } from "vuex";
import CameraEdit from "./module/cameraEdit.vue";
import EZUIKitPlayer from '../../../components/view/EZUIKitPlayer.vue'
export default {
    data() {
        return {
            defaultProps: {
                children: "nodeList",
                label: "cameraName",
                sn: "camerasn",
            },
            rightWidth: 0,
            projectCamera: {},
            dataList: [],
            project: {},
            cameraItems: [],
            editVisible: false,
            playerWidth: 1024,
            playerHeight: 600,
            template: 'simple',
        };
    },
    computed: {
        ...mapState(["buttonTextColor"]),
        ...mapState(["projectCurrentRowData"])
    },
    components: { 
        CameraEdit,
        EZUIKitPlayer
    },
    watch: {
        cameraItems: {
            handler(newVal) {
                // 延迟执行，确保DOM已更新
                this.$nextTick(() => {
                    setTimeout(() => {
                    // 调用每个播放器的调整大小方法
                    newVal.forEach((camera, index) => {
                        const playerRef = this.$refs[`player${index + 1}`];
                        if (playerRef && playerRef[0] && playerRef[0].adjustPlayerSize) {
                        playerRef[0].adjustPlayerSize();
                        }
                    });
                    }, 500);
                });
            },
            deep: true
        }
    },
    mounted() {
        this.project = this.projectCurrentRowData.projectCode;
        this.cameraList();
        this.rightWidth=this.$refs.pageRight?.clientWidth;
    },
    methods: {
       
        onPlayerReady(player) {
            console.log('播放器已就绪', player);
        },
        onPlayerError(error) {
            console.error('播放器错误:', error);
        },
        handleClose() {
            this.editVisible=false;
            this.cameraList();
        },
        // 新增树节点
        appendNode() {
            this.projectCamera={
                project: this.project
            };
            this.editVisible=true;
        },
        // 编辑树节点
        editNode(data) {
            this.projectCamera=data;
            this.editVisible=true;
        },
        // 删除树节点
        removeNode(data) {
            this.$confirm("确定删除选中摄像头么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(() => {
                var params = {};
                params["cameraSn"] = data.cameraSn;
                params['project'] = data.project;
                this.request.cameraDel(params).then((res) => {
                    if (res.code == 0) {
                        this.cameraItems=[];
                        this.$message.success("删除成功");
                        this.cameraList();
                    }
                });
            })
            .catch(() => { });
        },
        //点击节点触发
        treeClick(camera) {
            for (var i=0; i<this.cameraItems.length; i++) {
                if (camera.playUrl==this.cameraItems[i].playUrl) {
                    this.cameraItems.splice(i,1);
                    this.$forceUpdate();
                    return;
                }
            }
            this.cameraItems.push(camera);
            this.$forceUpdate();
        },
        //摄像头列表
        cameraList() {
            this.cameraItems=[];
            this.request.cameraList({project: this.project}).then((res) => {
                this.dataList=res.data;
            });
        },
    },
};
</script>


<style scoped>
.dilu-page {
    overflow: hidden;
}

.control-panel {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.control-panel button {
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
  margin-bottom: 10px;
}

.page-row {
    height: 100%;
}

.page-col {
    border-right: 1px solid #eee;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.page-col:last-child {
    border: none;
}

.tree {
    flex: 1;
    overflow: auto;
}

.page-right {
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
}

.depart-view {
    width: 100%;
    display: flex;
    height: 100%;
}

.depart-view-left {
    width: 18%;
    padding-right: 10px;
    box-sizing: border-box;
    flex-shrink: 0;
}

.depart-view-right {
    flex: 1;
    width: 77%;
    padding-left: 10px;
    margin-left: 10px;
    box-sizing: border-box;
    border-left: 1px solid #d7ddeb;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.el-tree ::v-deep.el-tree-node>.el-tree-node__content {
    height: 40px;
}

.show-hide:hover :nth-child(2) {
    display: inline-block !important;
}

.wgtitle {
    opacity: 0.9;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    padding: 0 5px;
    color: #000000;
    border-left: 4px solid #326FFF;
}

.addwg {
    width: 24px;
    height: 12px;
    opacity: 1;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #326FFF;
    padding: 0;
}

.addsb {
    border-radius: 4px;
    opacity: 1;
    background: #326FFF;
    margin: 10px 0;
}

.sbcard {
    padding: 15px 20px;
    line-height: 30px;
}

.cardval {
    opacity: 1;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 14px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0px;
    padding-left: 15px;
    font-variation-settings: "opsz" auto;
    color: rgba(0, 0, 0, 0.9);

}

.cardlabel {
    opacity: 1;
    text-align: right;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 12px;
    font-weight: normal;
    line-height: 12px;
    letter-spacing: 0px;
    color: rgba(0, 0, 0, 0.4);
}

.camera-grid {
  display: grid;
  gap: 10px;
  width: 100%;
  height: 100%;
}

.grid-1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

.grid-2 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  height: 50%;
}

.grid-3, .grid-4 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: 100%;
}

</style>